import { TableContainer, Table, TableCell, TableRow, Button } from '@mui/material';
import styled from '@emotion/styled';
import { shouldForwardProp } from '@/utils/shouldForwardProp';
import { CustomIconButton } from './IconButtonStyle';

// ===============================================
// 테이블 컨테이너 스타일 컴포넌트
// ===============================================
export const CustomTableContainer = styled(TableContainer)`
  box-shadow: 0;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: none;
`;

// ===============================================
// 테이블 스타일 컴포넌트
// ===============================================
export const CustomTable = styled(Table, { shouldForwardProp })`
  width: 100%;
  /* table-layout: fixed; */
  table-layout: auto;
  border-spacing: 0;
  border: 1px solid #e9eaeb;

  & thead + tbody td:has(input) {
    text-align: center;
  }

  & .MuiTableBody-root {
    & th {
      width: 240px;
      padding: 4px 8px 4px 20px;
    }
  }

  ${({ fourColumn }) =>
    fourColumn &&
    `
      & .MuiTableBody-root {
        & th {
          width: 17%;
        }
      }
    `}

  ${({ sixColumn }) =>
    sixColumn &&
    `
      & .MuiTableBody-root {
        & th {
          width: 15%;
        }
      }
    `}

  ${({ merge }) =>
    merge &&
    `
      & .MuiTableBody-root {
        & th {
        width: auto;
        padding: 4px 8px;
      }
    `}
`;

// ===============================================
// 테이블 행 스타일 컴포넌트
// ===============================================
export const CustomTableRow = styled(TableRow, { shouldForwardProp })`
  ${({ hover }) =>
    hover &&
    `
      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
        transition: background-color 0.2s ease;
        cursor: pointer;
      }
    `}
`;

// ===============================================
// 테이블 헤더 셀 스타일 컴포넌트
// ===============================================
export const HeaderCell = styled(TableCell, { shouldForwardProp })`
  position: relative;
  height: 40px;
  background-color: #fafafa;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 600;
  padding: 4px 8px;
  border: 1px solid #e9eaeb;
  white-space: nowrap;

  width: ${({ width }) => width || 'auto'};

  /* ${({ columns, minWidth = '120px' }) => `
    width: ${columns ? `${100 / columns}%` : 'auto'};
    min-width: ${minWidth};
  `} */
`;
export const CustomHeaderCell = (props) => <HeaderCell component="th" {...props} />;

// ===============================================
// 테이블 바디 셀 스타일 컴포넌트
// ===============================================
export const BodyCell = styled(TableCell, { shouldForwardProp })`
  height: 40px;
  color: rgba(0, 0, 0, 0.67);
  padding: 4px 8px;
  border: 1px solid #e9eaeb;
  word-break: break-all;

  width: ${({ width }) => width || 'auto'};

  // ${({ columns, minWidth = '120px' }) => `
  //   width: ${columns ? `${100 / columns}%` : 'auto'};
  //   min-width: ${minWidth};
  // `}

  .react-datepicker-wrapper {
    width: ${({ width }) => width || '100%'};
    max-width: ${({ maxWidth }) => maxWidth || '400px'};
  }
`;
export const CustomBodyCell = (props) => <BodyCell component="td" {...props} />;

export const CustomSorting = (props) => {
  const { sorted, children, ...rest } = props;
  return (
    <CustomIconButton active={sorted} {...rest}>
      {children}
    </CustomIconButton>
  );
};

// ===============================================
// 테이블 관련 모든 공통 스타일 정의 (추후 제거)
// ===============================================
export const tableStyles = {
  // 기본 테이블 스타일
  commonTable: {
    container: {
      width: '100%',
      boxShadow: 'none',
      borderRadius: 0,
    },
    table: {
      borderCollapse: 0,
    },
    headerCell: {
      backgroundColor: '#fafafa',
      border: '1px solid #E9EAEB',
      fontWeight: 'bold',
      padding: '8px 12px',
    },
    cell: {
      padding: '8px 12px',
      border: '1px solid #E9EAEB',
    },
    textField: {
      '& .MuiInputBase-input': {
        padding: '4px 8px',
      },
      '& .MuiInputBase-input::placeholder': {
        fontSize: 14,
      },
      '& .MuiFormHelperText-root': {
        fontSize: 14,
      },
    },
  },

  // ===============================================
  // 검색 테이블 스타일 (추후 제거)
  // ===============================================
  search: {
    headerCell: {
      backgroundColor: '#fafafa',
      border: '1px solid #E9EAEB',
      width: ({ columns = 2 }) => `${100 / columns}%`,
      minWidth: '120px',
      fontWeight: 'bold',
      padding: '4px 12px',
    },
    cell: {
      padding: '4px 8px',
      border: '1px solid #E9EAEB',
      width: ({ columns = 2 }) => `${100 / columns}%`,
    },
    button: {
      minWidth: '100px',
      backgroundColor: '#1976d2',
      color: '#ffffff',
      '&:hover': { backgroundColor: '#1565c0' },
      padding: '4px 8px',
    },
  },
};
